// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2W2M8","title":"Info_title__3M2GG","links":"Info_links__3bs-4","link":"Info_link__kV_4t","logo":"Info_logo__26YC3"};